import React from 'react';
import CinematicHero from '../components/sections/CinematicHero';
import MaisonSection from '../components/sections/MaisonSection';
import Gallery from '../components/sections/Gallery';
import Testimonials from '../components/sections/Testimonials';
import Footer from '../components/sections/Footer';
import Navbar from '../components/layout/Navbar';
import UniversSection from '../components/sections/UniversSection';
import RealisationsSection from '../components/sections/RealisationsSection';
import Partners from '../components/sections/Partners';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-[#FFFFFF] text-[#111111] font-sans selection:bg-[#111111] selection:text-white">
      <Navbar overlay />
      <main>
        <CinematicHero />
        <MaisonSection />
        <UniversSection />
        <RealisationsSection />
        <Gallery />
        <Testimonials />
        <Partners />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
